var React = require('react');

function IconRightArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Rectangle 4"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"PDP-Website","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Mobile-Navigation-Drop-Down-Tier-2","transform":"translate(-270.000000, -168.000000)","stroke":"#012639"},React.createElement("polyline",{"id":"Rectangle-4","transform":"translate(271.000000, 174.000000) scale(1, -1) rotate(-45.000000) translate(-271.000000, -174.000000) ","points":"275 170 275 178 267 178"})))]);
}

IconRightArrow.displayName = "IconRightArrow";

IconRightArrow.defaultProps = {"width":"8px","height":"12px","viewBox":"0 0 8 12","version":"1.1"};

module.exports = IconRightArrow;

IconRightArrow.default = IconRightArrow;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./app/javascript/images/icons/icon-right-arrow.svg
// module id = 1758
// module chunks = 0